<div class="p-fare-rule-detail-panel__head" tabindex="0">
  <div class="p-fare-rule-detail-panel__head-airport">
    <span class="c-flight-info01__title-airport-departure">
      {{ data.depLoc }}
      <span class="c-flight-info01__title-airport-to" [innerHTML]="'label.hyphen' | staticMsg"></span>
    </span>
    <span class="c-flight-info01__title-airport-arrival">
      {{ data.arrLoc }}
    </span>
  </div>
  <div class="p-fare-rule-detail-panel__body">
    <ng-container *ngFor="let condsPerPtc of data.condsPerPtc; index as i">
      <asw-fare-condition-details-per-bound-per-ptc
        [data]="condsPerPtc"
        [boundIndex]="boundIndex"
        [ptcIndex]="i"
      ></asw-fare-condition-details-per-bound-per-ptc>
    </ng-container>
  </div>
</div>
